import { HoneyloveWindow } from './models/HoneyloveWindow';
import { Shopify } from './models/Shopify.model';

const defaultValue: Shopify = {
  currency: { active: 'USD', rate: 1.0 },
};

export const shopify = typeof window !== 'undefined' ? (window as unknown as HoneyloveWindow).Shopify ?? defaultValue : defaultValue;
